import { DrawerDiaLog, DrawerDiaLogTitle } from '../drawer-dialog';
import { SellContext } from './sell-context';

export type SellModelProps = {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  marketAddress: string;
  optionAddress: string;
};
export const SellModel = ({ open, setOpen, marketAddress, optionAddress }: SellModelProps) => {
  return (
    <DrawerDiaLog
      open={open}
      setOpen={setOpen}
      transactionMarket={marketAddress}
      className="md:max-w-[23rem] p-4 pt-0 md:p-4"
    >
      <DrawerDiaLogTitle />
      <SellContext marketAddress={marketAddress} optionAddress={optionAddress} setOpen={setOpen} />
    </DrawerDiaLog>
  );
};
